import { css } from '@emotion/react';
import styled from '@emotion/styled';

import {
  Menu as BaseMenu,
  MenuDropdown as BaseMenuDropdown,
} from '@Calix-Commerce/design-system/components';

const INTERNAL_BORDER = '1px solid #c7c7c7';

const selectedOption = ({ theme }) => css`
  background: #ededed;

  span {
    color: ${theme.colors.secondary};
  }
`;

export const Menu = styled(BaseMenu)`
  width: 152px;
  line-height: 1.3;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const MenuDropdown = styled(BaseMenuDropdown)`
  width: 275px;
  padding: 1.07rem;

  & > svg {
    position: absolute;
    right: 0.7rem;
    top: 0.7rem;
    color: #666;
    font-size: 1.8rem;
    cursor: pointer;
    z-index: 1000;
  }
`;

export const MenuTotal = styled.div`
  margin-top: 0.4rem;
`;

export const Account = styled.div`
  position: relative;
  padding-bottom: 0.8rem;
  padding-right: ${({ showSettings }) => (showSettings ? '1.62rem' : '0')};
  border-bottom: ${INTERNAL_BORDER};
  margin-bottom: 0.5rem;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
`;

export const QuoteName = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const OptionStyled = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 3px 5px;
  font-weight: bold;
  border-radius: 0.29rem;

  span {
    flex-grow: 1;
    color: ${({ theme }) => theme.colors.action};
    text-align: left;
    text-transform: none;
  }

  img {
    width: 50px;
    height: 50px;
    margin-right: 0.3rem;
  }

  & > svg {
    color: ${({ theme }) => theme.colors.action};
    font-size: 1.72rem;
    margin: 0px 6.5px;
  }

  &:hover {
    ${selectedOption};
  }

  ${({ selected }) => (selected ? selectedOption : '')};
`;
